import { EnterpriseDashboardLocationDetails } from './enterprise-dashboard-location-details';
import { EnterpriseDashboardPerformanceLocationMonthlyChartData } from './enterprise-dashboard-performance-location-monthly-chart-data';

export class EnterpriseDashboardPerformanceLocationDetails extends EnterpriseDashboardLocationDetails {
	public totalUsage: number;
	public totalSupplyCost: number;
	public totalUtilityCost: number;
	public totalCostAvoidance: number;
	public monthlyChartData: EnterpriseDashboardPerformanceLocationMonthlyChartData[];

	constructor(enterpriseDashboardPerformanceLocationDetails?: EnterpriseDashboardPerformanceLocationDetails) {
		super(enterpriseDashboardPerformanceLocationDetails);
		Object.assign(this, enterpriseDashboardPerformanceLocationDetails);

		this.monthlyChartData = this.monthlyChartData
			? this.monthlyChartData.map(m => new EnterpriseDashboardPerformanceLocationMonthlyChartData(m))
			: [];
	}
}
